export const cgvPage = {
  kicker: 'Conditions contractuelles',
  title: 'Conditions générales de vente',
  intro:
    'Ces conditions encadrent les prestations de développement web réalisées par Alioune Badara Seck pour des clients agissant dans le cadre de leur activité professionnelle. Le devis ou contrat accepté reste prioritaire lorsqu’il prévoit des conditions particulières.',
  sections: [
    {
      title: '1. Identité du prestataire',
      definitions: [
        ['Prestataire', 'Alioune Badara Seck, entrepreneur individuel'],
        ['SIREN', '995 288 438'],
        ['SIRET', '995 288 438 00014'],
        ['Code APE', '62.01Z - Programmation informatique'],
        ['Adresse', '1 place Guy Ropartz, 29000 Quimper, France'],
        ['Email', 'contact@alioune-seck.dev'],
      ],
    },
    {
      title: '2. Champ d’application',
      paragraphs: [
        'Les présentes CGV s’appliquent aux prestations commandées à des fins professionnelles : création ou reprise de site, application web, e-commerce, réservation, paiement, back-office, automatisation, intégration API, maintenance, audit ou accompagnement technique.',
        'Elles constituent une trame B2B. Lorsqu’un client agit en qualité de consommateur ou de non-professionnel, des conditions adaptées lui sont communiquées avant toute commande.',
      ],
    },
    {
      title: '3. Formation du contrat',
      paragraphs: [
        'La mission débute après acceptation écrite du devis, de la proposition ou du contrat et, lorsqu’un acompte est prévu, après son encaissement.',
        'Une validation par signature électronique, signature manuscrite ou accord écrit non équivoque par email peut valoir acceptation. Le périmètre, le prix, les délais et les livrables décrits dans le devis accepté prévalent sur les présentes CGV.',
        'Les fourchettes affichées sur le site et le résultat de l’outil « Estimer mon projet » sont purement indicatifs. Ils ne constituent pas un devis et n’engagent pas le prestataire avant émission et acceptation d’une proposition commerciale adaptée au besoin réel.',
      ],
    },
    {
      title: '4. Périmètre et demandes supplémentaires',
      paragraphs: [
        'Le prix couvre uniquement les éléments expressément prévus au devis. Toute fonctionnalité, intégration, page, import de données, migration ou évolution demandée après validation du périmètre peut faire l’objet d’un chiffrage ou d’un avenant complémentaire.',
        'Une adaptation nécessaire pour livrer correctement une fonctionnalité prévue n’est pas assimilée à une demande supplémentaire. En revanche, un changement d’objectif, de fonctionnement ou de périmètre peut modifier le budget et le calendrier.',
      ],
    },
    {
      title: '5. Obligations du client',
      paragraphs: ['Le client s’engage à collaborer de manière raisonnable à la réalisation du projet, notamment à :'],
      list: [
        'fournir dans des délais utiles les contenus, accès, informations et validations nécessaires ;',
        'vérifier qu’il dispose des droits nécessaires sur les textes, images, marques, bases de données et autres contenus transmis ;',
        'signaler rapidement toute contrainte métier, réglementaire ou technique susceptible d’affecter le projet ;',
        'effectuer les recettes et retours demandés avec suffisamment de précision pour permettre leur reproduction.',
      ],
      after: [
        'Un retard dans la transmission des éléments ou validations peut entraîner un décalage équivalent du calendrier sans engager la responsabilité du prestataire.',
      ],
    },
    {
      title: '6. Délais et planning',
      paragraphs: [
        'Les délais annoncés sont des estimations sauf engagement ferme expressément indiqué au devis. Ils commencent lorsque les conditions de démarrage sont réunies, notamment l’accord, l’acompte éventuel et la remise des éléments nécessaires.',
        'Le planning peut être révisé en cas de demande supplémentaire, retard de validation, indisponibilité d’un service tiers, incident extérieur au prestataire ou force majeure.',
      ],
    },
    {
      title: '7. Prix, facturation et paiement',
      paragraphs: [
        'Les prix sont indiqués en euros. Le régime de TVA appliqué est celui en vigueur au jour de la facturation. Lorsque la franchise en base de TVA est applicable, la facture comporte la mention réglementaire correspondante.',
        'Les modalités du devis priment. À défaut de calendrier spécifique, le paiement est réparti à hauteur de 40 % à la commande, 40 % lors de la mise à disposition d’une version fonctionnelle et 20 % à la livraison ou mise en production.',
        'Sauf mention différente sur le devis ou la facture, les factures sont payables dans un délai de 7 jours à compter de leur date d’émission. Aucun escompte n’est accordé pour paiement anticipé.',
      ],
    },
    {
      title: '8. Retard ou défaut de paiement',
      paragraphs: [
        'Pour un client professionnel, tout retard entraîne de plein droit l’application de pénalités calculées au taux de refinancement de la Banque centrale européenne applicable au semestre concerné, majoré de 10 points, sans pouvoir être inférieur au minimum légal.',
        'Lorsque les dispositions du Code de commerce sont applicables, une indemnité forfaitaire de 40 € pour frais de recouvrement est due pour chaque facture payée en retard. Une indemnisation complémentaire peut être demandée sur justificatifs si les frais réellement exposés sont supérieurs.',
        'Le prestataire peut suspendre les travaux, l’accès à un environnement de préproduction ou une mise en ligne tant qu’une échéance exigible reste impayée, après information du client.',
      ],
    },
    {
      title: '9. Livraison, recette et corrections',
      paragraphs: [
        'Le client est invité à vérifier les livrables dès leur mise à disposition. Les anomalies doivent être décrites de manière suffisamment précise et, si possible, accompagnées des étapes permettant de les reproduire.',
        'Sauf délai différent prévu au devis, le client dispose de 7 jours ouvrés pour signaler les anomalies bloquantes relevant du périmètre convenu. L’absence de remarque bloquante dans ce délai permet de considérer la livraison comme recevable pour la facturation ou la mise en production, sans priver le client de ses droits impératifs.',
        'Pendant 30 jours après la livraison, le prestataire corrige sans coût supplémentaire les défauts reproductibles directement imputables à son développement et entrant dans le périmètre accepté. Les évolutions, nouveaux besoins, incidents liés à un tiers ou modifications réalisées par une autre personne ne sont pas couverts par cette période.',
      ],
    },
    {
      title: '10. Services tiers, hébergement et noms de domaine',
      paragraphs: [
        'Le projet peut dépendre de services tiers tels que l’hébergement, un registrar, Stripe, un service email, une API, une bibliothèque ou un outil SaaS. Leurs conditions, tarifs, limites et disponibilités relèvent de leurs éditeurs respectifs.',
        'Sauf mention contraire au devis, les abonnements, noms de domaine, frais de transaction et licences tierces restent à la charge du client.',
        'Le prestataire ne peut garantir la disponibilité permanente d’un service tiers ni être tenu responsable d’une panne, modification d’API, suspension ou changement tarifaire indépendant de son contrôle.',
      ],
    },
    {
      title: '11. Propriété intellectuelle et code',
      paragraphs: [
        'Le client garantit qu’il dispose des droits nécessaires sur les éléments qu’il fournit au prestataire.',
        'Après paiement intégral des sommes dues, les droits patrimoniaux sur les créations spécifiques réalisées exclusivement pour le client sont cédés ou concédés dans l’étendue nécessaire à l’exploitation prévue par le projet, sous réserve des éléments tiers, open source, polices, bibliothèques et licences qui conservent leurs propres conditions.',
        'Le prestataire conserve ses méthodes, son savoir-faire, ses outils internes et les composants génériques ou réutilisables qui ne sont pas spécifiques au client. Leur présence dans un projet n’empêche pas le client d’exploiter normalement le livrable final.',
      ],
    },
    {
      title: '12. Référence commerciale et confidentialité',
      paragraphs: [
        'Chaque partie s’engage à préserver les informations identifiées comme confidentielles et reçues dans le cadre du projet.',
        'Après publication du projet, le prestataire peut citer le nom ou la marque du client et présenter des captures ou une description du travail dans son portfolio et ses supports professionnels, sauf refus écrit du client ou obligation de confidentialité contraire.',
      ],
    },
    {
      title: '13. Données personnelles',
      paragraphs: [
        'Chaque partie reste responsable des traitements de données qu’elle détermine pour son propre compte.',
        'Lorsque le prestataire traite des données personnelles uniquement pour le compte du client dans le cadre de la réalisation technique, les obligations respectives peuvent être précisées dans le devis, le contrat ou un accord de sous-traitance adapté au projet.',
        'Le client reste notamment responsable de la licéité des données, des informations fournies aux utilisateurs et de la définition des durées de conservation applicables à son propre service.',
      ],
    },
    {
      title: '14. Sécurité, sauvegardes et maintenance',
      paragraphs: [
        'Le prestataire met en œuvre des pratiques raisonnables de développement et de sécurité adaptées au périmètre commandé. Aucun service informatique ne peut toutefois être garanti comme totalement exempt de vulnérabilité ou d’interruption.',
        'Après livraison, la maintenance corrective, les mises à jour de dépendances, la supervision, les sauvegardes et les interventions d’urgence ne sont incluses que lorsqu’elles sont expressément prévues au devis ou dans une offre de maintenance.',
      ],
    },
    {
      title: '15. Responsabilité',
      paragraphs: [
        'Le prestataire est responsable des dommages directs et prévisibles résultant d’un manquement qui lui est imputable. Il ne répond pas des pertes indirectes telles que perte de chiffre d’affaires, perte d’opportunité, perte de données non sauvegardées par le client ou atteinte résultant d’un service tiers, sauf disposition impérative contraire.',
        'Dans les relations entre professionnels et sous réserve des règles impératives, la responsabilité financière du prestataire au titre d’une mission est limitée au montant hors taxes effectivement payé pour la prestation directement à l’origine du dommage.',
        'Aucun résultat commercial, référencement naturel, niveau de ventes, trafic, disponibilité d’un service tiers ou performance économique n’est garanti sauf engagement chiffré et écrit au devis.',
      ],
    },
    {
      title: '16. Suspension et résiliation',
      paragraphs: [
        'En cas de manquement sérieux d’une partie à ses obligations, l’autre partie peut demander sa régularisation par écrit et, si le manquement persiste, mettre fin à la mission dans les conditions prévues au devis ou au contrat.',
        'En cas d’arrêt demandé par le client après le démarrage, les travaux réalisés, temps engagé et frais non récupérables restent dus. Les sommes déjà versées sont imputées sur ces montants.',
        'Les fichiers et livrables dont le prix a été intégralement réglé sont remis au client dans l’état atteint à la date de fin de mission, sous réserve des éléments appartenant à des tiers ou au prestataire.',
      ],
    },
    {
      title: '17. Force majeure',
      paragraphs: [
        'Aucune partie n’est responsable d’un retard ou d’une inexécution directement causée par un événement échappant raisonnablement à son contrôle et présentant les caractéristiques de la force majeure au sens du droit français. La partie concernée informe l’autre dès que possible.',
      ],
    },
    {
      title: '18. Droit applicable et règlement des litiges',
      paragraphs: [
        'Les présentes CGV sont soumises au droit français. Les parties privilégient d’abord une résolution amiable et écrite de tout différend.',
        'À défaut d’accord amiable, le litige relève des juridictions matériellement et territorialement compétentes selon les règles de droit commun, sauf clause particulière valable figurant dans le devis ou le contrat.',
      ],
    },
    {
      title: '19. Hiérarchie des documents',
      paragraphs: [
        'En cas de contradiction, l’ordre de priorité est le suivant : conditions particulières ou contrat signé, devis accepté, éventuel avenant, puis présentes CGV.',
        'La nullité éventuelle d’une clause n’affecte pas la validité des autres dispositions.',
      ],
    },
  ],
  links: [
    { to: '/mentions-legales', label: 'Mentions légales' },
    { to: '/politique-confidentialite', label: 'Politique de confidentialité' },
    { to: '/cgu', label: 'CGU du site' },
  ],
};
